import { getAPIProps, TimeRange } from '@mulesoft/monitoring-center-components/lib/components/BuiltInDashboards/PreBuilt'
import { DashboardError, DashboardLoadingState } from '@mulesoft/monitoring-center-components'
import { APIDetail, ManagedAPI } from '@mulesoft/monitoring-center-components/lib/models/api-manager'
import { Profile } from '../../../remote-api/CoreServicesRemoteApi'

import {
  DashboardItem
} from '@mulesoft/monitoring-center-components/lib/components/BuiltInDashboards/BuiltInDashboardsContent/BuiltInDashboardsContent'

import HttpMetricsOverviewBuilder
  from '@mulesoft/monitoring-center-components/lib/components/BuiltInDashboards/PreBuilt/APIAnalytics/Overview/HttpMetricsOverviewBuilder'
import HttpMetricsRequestsBuilder
  from '@mulesoft/monitoring-center-components/lib/components/BuiltInDashboards/PreBuilt/APIAnalytics/Requests/HttpMetricsRequestsBuilder'
import HttpMetricsPoliciesBuilder
  from '@mulesoft/monitoring-center-components/lib/components/BuiltInDashboards/PreBuilt/APIAnalytics/Policies/HttpMetricsPoliciesBuilder'
import HttpMetricsFailuresBuilder
  from '@mulesoft/monitoring-center-components/lib/components/BuiltInDashboards/PreBuilt/APIAnalytics/Failures/HttpMetricsFailuresBuilder'
import HttpMetricsPerformanceBuilder
  from '@mulesoft/monitoring-center-components/lib/components/BuiltInDashboards/PreBuilt/APIAnalytics/Performance/HttpMetricsPerformanceBuilder'
import HttpMetricsClientsBuilder
  from '@mulesoft/monitoring-center-components/lib/components/BuiltInDashboards/PreBuilt/APIAnalytics/Clients/HttpMetricsClientsBuilder'
import { dashboardRegistry } from '../dashboardType'
import { isFlex } from '../../../util/flex';

export function getAPIAnalyticsDashboards(profile: Profile | undefined,
                                          resource: APIDetail | ManagedAPI,
                                          range: TimeRange,
                                          onDashboardFunctions: {
                                            onDashboardStateChange: (loading: DashboardLoadingState, uri: string, iframe?: HTMLIFrameElement) => void
                                            onDashboardError: (error: DashboardError) => void
                                          },
                                          isTitanium: boolean): DashboardItem[] {
  const basicProps = getAPIProps(resource, range, onDashboardFunctions)
  const props = {...basicProps, isTitanium, profile}
  const policiesEnabled = window.mc.featureFlags.builtIn.apiMetrics.policies.enabled === 'true'

  const overview = new HttpMetricsOverviewBuilder(props)
  const requests = new HttpMetricsRequestsBuilder(props)
  const policies = new HttpMetricsPoliciesBuilder(props)
  const failures = new HttpMetricsFailuresBuilder(props)
  const performance = new HttpMetricsPerformanceBuilder(props)
  const clients = new HttpMetricsClientsBuilder(props)

  const defaultTabs = [
    {
      item: dashboardRegistry.overview,
      get: () => overview.buildDashboard()
    },
    {
      item: dashboardRegistry.requests,
      get: () => requests.buildDashboard()
    },
    {
      item: dashboardRegistry.failures,
      get: () => failures.buildDashboard()
    },
    {
      item: dashboardRegistry.performance,
      get: () => performance.buildDashboard()
    },
    {
      item: dashboardRegistry.clients,
      get: () => clients.buildDashboard()
    }
  ]

  const policyTab = policiesEnabled ? [
    {
      item: dashboardRegistry.policies,
      get: () => policies.buildDashboard()
    }
  ] : []

  const defaultDashboard = [...defaultTabs.slice(0, 3), ...policyTab, ...defaultTabs.slice(3)];

  return isFlex(resource) ? [...defaultDashboard.slice(0, policiesEnabled ? 4 : 3), ...defaultDashboard.slice(policiesEnabled ? 5 : 4)] : defaultDashboard
}
